<template>
  <div class="container">
    <div class="yield-rate-style">
      <div class="report-label">
        <p>巡查任务达成率</p>
      </div>
      <div class="condition">
        <span>请选择基地：</span>
          <j-dict-select-tag ref="baseRef"   placeholder="请选择基地"  v-model="baseId" :isChooseFirst="true" dictCode="bus_inspection_general_base,base,id,status=1"  >
          </j-dict-select-tag>
        <span style="margin-left: 3%">请选择角色：</span>
          <a-select class="min-width-con" v-model="roleId" @focus="getBaseUserRole">
            <a-select-option v-for="(item) in userRoleList" :key="item.id" :value="item.id">
              {{ item.roleName }}
            </a-select-option>
          </a-select>
        <span style="margin-left: 3%">请选择统计时间区间：</span>
        <a-range-picker @change="onChange" />
      </div>
      <div class="emptydiv" v-if="description">
        <a-empty style="margin-top: 10%; margin-bottom: 10%" />
      </div>
      <div class="report-view" v-if="!description">
        <a-skeleton active :loading="loadingDate" style="margin-left: 5%; width: 90%" />
        <v-chart
          :forceFit="false"
          :height="height"
          :data="data"
          :padding="padding"
          :width="1200"
          :scale="scale"
          v-if="!loadingDate"
        >
          <v-coord type="rect" direction="LB" />
          <v-tooltip :shared="true" />
          <v-axis dataKey="name" :label="label" />
          <v-interval position="name*rate" :label="labelInterval" :color="color" />
        </v-chart>
      </div>
    </div>
  </div>
</template>

<script>
import { countAchievementRateOfGeneral,findInspectionRoleOfGeneral,busInspectionBaseList  } from '@/api/api'

const DataSet = require('@antv/data-set')

const label = { offset: 12 }

const scale = [
  {
    dataKey: 'rate',
    nice: false,
    alias: '完成率(%)',
  },
]

const labelInterval = [
  'rate',
  {
    useHtml: true,
    htmlTemplate: function htmlTemplate(text, item) {
      var a = item.point
      return '<span class="g2-label-item"><p class="g2-label-item-value" >' + a.rate + '%</p></div>'
    },
  },
]

const color = [
  'rate',
  function (val) {
    if (val <= 50) {
      return '#ff4d4f'
    } else if (val > 50 && val <= 70) {
      return '#FF8C00'
    } else if (val > 70 && val < 90) {
      return '#2194ff'
    } else {
      return '#90EE90'
    }
  },
]

export default {
  data() {
    return {
      data: [],
      height: 1200,
      label: label,
      labelInterval,
      padding: { top: 20, right: 100, bottom: 20, left: 150 },
      scale,
      color,
      roleId: '',
      baseId: '',
      startDate: '',
      endDate: '',
      userIsAdmin: false,
      userBaseList: [],
      userRoleList: [],
      description: false,
      loadingDate: false,
      baseList:null,
    }
  },
  mounted() {
  },
  watch:{
    "baseId":{
        deep:true,
        handler(newValue){
          this.handlerBaseChange(newValue);
          this.getData()
          // this.departIdDict="bus_inspection_general_base_depart,depart,id,status='1'"
        }
      },
      "roleId"(){
          this.getData()
      }
  },
  methods: {
    getBaseUserRole() {
      if (this.baseId== '' && this.baseId== null) { 
        this.$message.error('请先选择基地')
      }
    },
    onChange(date, dateString) {
      this.startDate = dateString[0]
      this.endDate = dateString[1]
      this.getData()
    },
    getData() {
      this.loadingDate = true
      let queryParam = {
        base: this.base,
        baseId: this.baseId,
        endDate: this.endDate,
        hasAdmin: this.userIsAdmin,
        startDate: this.startDate,
        roleId: this.roleId,
        userNo: this.$ls.get('Login_Userinfo').username,
      }
      countAchievementRateOfGeneral(queryParam).then((res) => {
        if (res.success) {
          const sourceData = res.result
          if (res.result.length <= 0) {
            this.description = true
          } else {
            this.description = false
            let hNum = res.result.length / 4
            if (hNum < 1) {
              hNum = 1
            }
            this.height = hNum * 300
            const dv = new DataSet.View().source(sourceData)
            dv.transform({
              type: 'sort',
              callback(a, b) {
                return a.population - b.population > 0
              },
            })
            this.data = dv.rows
          }
        } else {
          this.$message.error(res.message)
        }
        this.loadingDate = false
      })
    },
    busInspectionBaseList(){
      return new Promise((resolve,reject)=>{
        busInspectionBaseList({pageSize:100,pageNo:1}).then(res=>{
          if(res.code==200){
            resolve(res.result.records);
          }else{
            this.$message.error(res.message)
            reject([])
          }
        }).catch(error=>{
          this.$message.error(error.message)
          reject([])
        })
      })
    },
    async handlerBaseChange(newValue){
        if(newValue){
            this.departIdDict=`bus_inspection_general_base_depart,depart,id,status='1' AND base_id='${newValue}'`
            if(!this.baseList){
              this.baseList=await this.busInspectionBaseList();
            }
            //获取该基地下的角色信息
            this.$nextTick(()=>{
              let inspectionBase=""
              let baseLabel=this.$refs.baseRef.getSelectLabels()
              this.baseList.some(item=>{
                if(item.base===baseLabel){
                  inspectionBase=item.baseNo
                }
              })
              findInspectionRoleOfGeneral(inspectionBase).then((res) => {
                if (res.success) {
                  this.userRoleList = res.result
                  this.userRoleList.splice(0, 0, {
                    roleCode: '',
                    roleName: '全部',
                  })
                } else {
                  this.$message.error(res.message)
                }
              })
            })
            return
          }
          this.departIdDict="bus_inspection_general_base_depart,depart,id,status='1'"
      }
  },
}
</script>


<style lang="less" scoped>
.yield-rate-style {
  background: #ffffff;
  padding-bottom: 30px;
}
.report-label {
  font-size: 18px;
  font-weight: 550;
  padding-top: 10px;
  text-align: center;
}
.emptydiv {
  background: #ffffff;
  text-align: center;
}
.condition{
  margin-left: 5%;
  display: flex;
  align-items: center;
  .min-width-con{
    width: 150px;
  }
}
</style>
